import React from 'react';
import { Help } from '../help';

export type FieldsetProps = React.FieldsetHTMLAttributes<HTMLFieldSetElement> & {
  legend?: string;
  smallLegend?: boolean;
  help?: string;
  className?: string;
};

export const Fieldset = ({ legend, help, children, className = '', smallLegend = false, ...additionalAttributes }: FieldsetProps) => {
  return (
    <fieldset className={`fieldset${className ? ` ${className}` : ''}`} {...additionalAttributes}>
      {legend && (
        <legend style={{ fontSize: smallLegend ? 'small' : 'auto' }} className="float-none">
          {legend} {help && <Help placement="top">{help}</Help>}
        </legend>
      )}
      {children}
    </fieldset>
  );
};
